/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from 'modules/dashboard/components/tab-container/regional-map-tab/slice';
//
const selectDomain = (state) => state[SLICE.REGIONAL_MAP] || initialState;
/**
 * Getting region map filter list state for dashboard component
 */
export const selectRegionMapFilterList = createSelector(
  [selectDomain],
  (state) => state.regionMapFilterList
);
/**
 * Getting region map booking date state for dashboard component
 */
export const selectRegionMapBookingDate = createSelector(
  [selectDomain],
  (state) => state.regionMapBookingDate
);
/**
 * Getting region map chart breakdown state for dashboard component
 */
export const selectRegionMapChartBreakdown = createSelector(
  [selectDomain],
  (state) => state.regionMapChartBreakdown
);
/**
 * Getting region map focus on state for dashboard component
 */
export const selectRegionMapFocusOn = createSelector(
  [selectDomain],
  (state) => state.regionMapFocusOn
);
/**
 * Getting regional map otb state for dashboard component
 */
export const selectRegionalMapOtb = createSelector(
  [selectDomain],
  (state) => state?.regionalMapOtb
);
/**
 * Getting is region detailed in region map tab state for dashboard component
 */
export const selectIsRegionDetailed = createSelector(
  [selectDomain],
  (state) => state?.isRegionDetailed
);
/**
 *  Getting generated regional map tab url
 */
export const selectRegionalMapUrl = createSelector([selectDomain], (state) => state.regionalMapUrl);
/**
 * Getting total occupied rooms table view enable status into the dashboard component
 */
export const selectRegionalBreakdownTabularView = createSelector(
  [selectDomain],
  (state) => state.regionalBreakdownTabularView
);
/**
 * Getting total occupied rooms table view enable status into the dashboard component
 */
export const selectIsFocusOnSet = createSelector([selectDomain], (state) => state.isFocusOnSet);
/**
 * Getting regional map is display state into the component
 */
export const selectRegionIsDisplay = createSelector(
  [selectDomain],
  (state) => state.regionIsDisplay
);
/**
 * Getting into regional map tabular is display state the component
 */
export const selectRegionTabularIsDisplay = createSelector(
  [selectDomain],
  (state) => state.regionTabularIsDisplay
);
/**
 * Getting regional map selection for regional map tab into the component
 */
export const selectRegionalMapSelection = createSelector(
  [selectDomain],
  (state) => state.regionalMapSelection
);
/**
 * Getting regional map level for regional map tab into the component
 */
export const selectRegionalMapLevel = createSelector(
  [selectDomain],
  (state) => state.regionalMapLevel
);
/**
 * Getting regional map data loading status for regional map tab into the component
 */
export const selectRegionalMapDataLoading = createSelector(
  [selectDomain],
  (state) => state.dataLoading
);
/**
 * Getting regional data for regional map tab into the component
 */
export const selectRegionalData = createSelector([selectDomain], (state) => state?.regionalData);
/**
 * Getting regional drill down for regional map tab into the component
 */
export const selectIsDrillDown = createSelector([selectDomain], (state) => state?.isDrillDown);
/**
 * Getting regional full data for regional map tab into the component
 */
export const selectRegionalFullData = createSelector([selectDomain], (state) => state?.regionalFullData);
/**
 * Getting regional map full data loading status for regional map tab into the component
 */
export const selectRegionalMapFullDataLoading = createSelector(
  [selectDomain],
  (state) => state.fullDataLoading
);